import script from "./teachingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./teachingPage.vue?vue&type=script&lang=ts&setup=true"

import "./teachingPage.vue?vue&type=style&index=0&id=10233612&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4390a2cfce3e8645dfb3e8bd3a167747/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10233612"]])

export default __exports__